import { Component, OnInit, ElementRef, Input, Renderer2 } from '@angular/core';
import { DashboardService } from '../../dashboard.service';
import { AgendaModel, RdvDisplay } from '../../../models';
import { CoreService, HttpService, CoreAnimation } from '../../../services';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-dashboard-item-agenda',
  templateUrl: './dashboard-item-agenda.component.html',
  styleUrls: ['./dashboard-item-agenda.component.css']
})

export class DashboardItemAgendaComponent implements OnInit {

  // #region VARIABLES GLOBALES

  // #region public
  public listRdv: RdvDisplay[];
  public date: string;
  public sizes: {width: string, height: string};
  // #endregion

  // #region private
  private sliderBegin: number;
  private sliderEnd: number;
  private relativeHeight: number;
  private absoluteHeight: number;
  private cursorPosition: number;
  // #endregion

  // #endregion

  // #region DIRECTIVES
  @Input() id: string;
  @Input() idCpt: string;
  @Input() title: string;
  @Input() set size(value: {height: number, width: number}) {
    this.sizes = {
      width: value.width + 'px',
      height: value.height - 40 + 'px'
    };
    this.relativeHeight = value.height - 30;
  }
  // #endregion

  // #region CONSTRUCTEUR
  constructor(
    protected indParam: CoreService,
    protected http: HttpService,
    protected dashboardservice: DashboardService,
    protected element: ElementRef,
    protected render: Renderer2,
    protected animation: CoreAnimation
  ) { }
  // #endregion

  // #region CYCLE DE VIE
  ngOnInit(): void {

    const getDate: any = (): any => {
      const d: Date = new Date(Date.now());
      const getDay: any = (): any => {
        const j: string = `${d.getDate()}`;
        return j.length < 2 ? `0${j}` : `${j}`;
      };
      const getMonth: any = (): any => {
        const m: string = `${d.getMonth() + 1}`;
        return m.length < 2 ? `0${m}` : `${m}`;
      };
      const getYear: any = (): any => {
        return d.getFullYear();
      };
      const day: string = getDay();
      const month: string = getMonth();
      const year: string = getYear();
      return `${year}${month}${day}`;
    };
    const dateInit: any = getDate();

    // Recupere les evenements de la journée
    // tslint:disable-next-line:max-line-length
    this.http.getHttp<AgendaModel>(`${this.indParam.AppParams.apiUrl}api/Agenda/getData/INITRDVDAY/${dateInit}|32627,374`).subscribe(
      (res: AgendaModel)  => {
      const dateJour: Date = new Date(res.ListDay[0].Date);
      const year: number = dateJour.getFullYear();
      const month: string = dateJour.getMonth() + 1 < 10 ? `0${dateJour.getMonth() + 1}` : `${dateJour.getMonth() + 1}`;
      const day: string = dateJour.getDate() < 10 ? `0${dateJour.getDate()}` : `${dateJour.getDate()}`;

      this.date = `${day}/${month}/${year}`;
      this.listRdv = res.ListDay[0].ListRdv;

      //// Définit les différentes propriétés de taille du component en fonction du nombre d'évenement de la journée
      this.cursorPosition = 0;
      setTimeout(() => {
        this.absoluteHeight = this.element.nativeElement.children[0].children[2].children[0].offsetHeight;
      }, 0);
      this.sliderBegin = 0;
      this.sliderEnd = 0;
    });
  }
  // #endregion

  // #region FONCTIONS PUBLIQUES

  // Animation de la roulette de la souris
  public handleEvent = (event: WheelEvent): void => {
    event.preventDefault();
    event.stopPropagation();
    if (event.deltaY < 0) {
      if ((this.relativeHeight + this.cursorPosition) < this.absoluteHeight) {
        this.top();
      }
    } else {
      if (this.sliderBegin < 0) {
        this.bottom();
      }
    }
  }
  // #endregion

  // #region FONCTIONS PRIVEES

  // Animation si roulette souris vers le haut
  private top(): void {
    const element: any = this.element.nativeElement.children[0].children[2].children[0];
    const duration: number = 30;
    this.sliderEnd = this.sliderBegin - 20;
    const begin: {top: string} = { top: this.sliderBegin + 'px' };
    const end: {top: string} = { top: this.sliderEnd + 'px' };
    this.animation.wheelAnimation(element, duration, begin, end);
    this.sliderBegin = this.sliderEnd;
    this.cursorPosition += 20;
  }

  // Animation si roulette souris vers le bas
  private bottom(): void {
    const element: any = this.element.nativeElement.children[0].children[2].children[0];
    const duration: number = 30;
    this.sliderEnd = this.sliderBegin + 20;
    const begin: {top: string} = { top: this.sliderBegin + 'px' };
    const end: {top: string} = { top: this.sliderEnd + 'px' };
    this.animation.wheelAnimation(element, duration, begin, end);
    this.sliderBegin = this.sliderEnd;
    this.cursorPosition -= 20;
  }
  // #endregion

}
